$(function() {
	$('#languageSelection').change(function e() {
		var lang = $(this).val();
		if (lang) {
			$.cookie('siteLocale', lang, {
				expires : 365,
				path : '/'
			});

		}
		reloadPage();
	});

	$('#currencySelection').change(function e() {
		var currency = $(this).val();
		if (currency) {
			$.cookie('currency', currency, {
				expires : 365,
				path : '/'
			});
			
			try {
				var curr = $('input[type=hidden][name=reload_currency]');
				if(curr != null && curr.length > 0)
					$('input[type=hidden][name=reload_currency]').val(currency);
				else{
					var postForm = $("#postForm");
					$('<input>').attr({
						type: 'hidden',
					    name: 'reload_currency',
					    value: currency
					}).appendTo(postForm);
				}

			} catch (e) {
				// TODO: handle exception
			}
		}
		reloadPage();
	});

	var currency = $.cookie('currency');
	if (currency) {
		$("#currencySelection").val(currency);
	}

	var siteLocale = $.cookie('siteLocale');
	if (siteLocale) {
		$('#languageSelection').val(siteLocale);
    }

	window.onpopstate = function() {
	    var open_modal = document.querySelector('.modal.show')
	    if (open_modal) {
	        open_modal.dataset.pushback = 'true';
	        $(open_modal).modal('hide')
	    }
	}
	
	window.onunload = function() {
	    var open_modal = document.querySelector('.modal.show')
	    if (open_modal) {
	        open_modal.dataset.pushback = 'true';
	        $(open_modal).modal('hide')
	    }
	}

	$('#loading').modal('hide');
	
	$(".loading-link").click(function() {
		$('#loading').modal('show');
	});

	$('[data-bs-toggle="tooltip"]').tooltip();
	
	//Scroll top top
	var mybutton = document.getElementById("btn-back-to-top");

	// When the user scrolls down 20px from the top of the document, show the button
	window.onscroll = function () {
	  scrollFunction();
	};
	
	function scrollFunction() {
	  if (
	    document.body.scrollTop > 500 ||
	    document.documentElement.scrollTop > 500
	  ) {
	    mybutton.style.display = "block";
	  } else {
	    mybutton.style.display = "none";
	  }
	}
	// When the user clicks on the button, scroll to the top of the document
	mybutton.addEventListener("click", backToTop);
	
	function backToTop() {
	  document.body.scrollTop = 0;
	  document.documentElement.scrollTop = 0;
	}
});

function reloadPage() {
	window.location.reload();
}

function closePrivacyBox(){
	$('#dialog').hide();
	setPrivacyValueToCookie("privacyPopup", "closed");
	
}
function setPrivacyValueToCookie(name, value) {
		$.cookie(name, value, { expires : 365, path : '/' });
}

function setTimezoneCookie(){

    var timezone_cookie = "timezoneoffset";

    // if the timezone cookie not exists create one.
    if (!$.cookie(timezone_cookie)) {

        // check if the browser supports cookie
        var test_cookie = 'test cookie';
        $.cookie(test_cookie, true);

        // browser supports cookie
        if ($.cookie(test_cookie)) {

            // delete the test cookie
            $.cookie(test_cookie, null);

            // create a new cookie
            $.cookie(timezone_cookie, new Date().getTimezoneOffset());
        }
    }
    // if the current timezone and the one stored in cookie are different
    // then store the new timezone in the cookie and refresh the page.
    else {

        var storedOffset = parseInt($.cookie(timezone_cookie));
        var currentOffset = new Date().getTimezoneOffset();

        // user may have changed the timezone
        if (storedOffset !== currentOffset) {
            $.cookie(timezone_cookie, new Date().getTimezoneOffset());
        }
    }
}
